import { render } from "./Answer.vue?vue&type=template&id=3f1a9902&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"

import "./Answer.vue?vue&type=style&index=0&id=3f1a9902&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1a9902"]])

export default __exports__